module.exports = __webpack_public_path__ + "html/project-buttons_c59265db494cc07d038475e530077eb2.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/project/project-buttons.html
// module id = vhpm
// module chunks = 118